<adapt-collapsible-search-row [result]="result"
                              [matches]="matches"
                              [href$]="href$"
                              [ngClass]="{ 'no-container': !showContainer }">
    <div class="d-flex flex-grow-1 align-items-center justify-content-between">
        <div class="d-flex flex-grow-0 me-2 align-items-center text-muted">
            <div class="d-flex align-items-center result-icon"
                 adaptTooltip="Page">
                <i class="fal fa-file-alt fa-inverse"></i>
            </div>
        </div>

        <div class="flex-grow-1 text-break d-flex align-items-center breadcrumbs">
            <ol class="breadcrumbs-directive">
                @if (nodeExists(nodes.root)) {
                    <li>
                        <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: nodes.root }"></ng-container>
                    </li>
                }
                @if (nodeExists(nodes.area)) {
                    <li>
                        <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: nodes.area }"></ng-container>
                    </li>
                }
                @for (node of nodes.branches; track node) {
                    <li>
                        <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: node }"></ng-container>
                    </li>
                }
                @if (nodeExists(nodes.leafParent)) {
                    <li>
                        <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: nodes.leafParent }"></ng-container>
                    </li>
                }
                <li>
                    <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: nodes.leaf }"></ng-container>
                </li>
            </ol>
        </div>
    </div>
</adapt-collapsible-search-row>

<ng-template #nodeTemplate
             let-node="node">
    @if (nodeTitle(node); as title) {
        <span class="navigation-node-text">{{ title }}</span>
    }
</ng-template>
